import { IFormConfiguration } from "../../../../hooks/useFilterConfig";

import { valuesToParams } from "../filters.functions";

import { WorkOrderFilterFields } from "./work-order-filters.component";
import { paramsToValues } from "./work-order-filters.functions";
import { validation } from "./work-order-filters.validation";

export const WorkOrderFilter: IFormConfiguration = {
  Fields: WorkOrderFilterFields,
  paramsToValues,
  validation,
  valuesToParams,
};
